import GeolocationServices from 'services/GeolocationServices';
import { handleError } from 'store/error/actions';
import { DfdError } from 'store/error/types';
import { getBrowserName } from 'lib/browser';
import { Thunk } from 'store/types';
import { geolocationErrorShownSelector } from 'store/geolocation/selectors';
import { GeolocationBrowserSettingsMessages } from './types';

export const SET_GEO_LOCATION = 'GLOBAL.SET_GEO_LOCATION' as const;
export const SET_GEO_LOCATION_FAIL = 'GLOBAL.SET_GEO_LOCATION_FAIL' as const;
export const SET_GEO_LOCATION_ERROR_SHOWN = 'GLOBAL.SET_GEO_LOCATION_ERROR_SHOWN' as const;

export const setGeoLocation = (value: Position) => ({
  type: SET_GEO_LOCATION,
  payload: value
});

export const setGeoLocationFailure = (error: any) => ({
  type: SET_GEO_LOCATION_FAIL,
  error
});

export const setGeoLocationErrorShown = (errorShown: boolean) => ({
  type: SET_GEO_LOCATION_ERROR_SHOWN,
  errorShown
});

export const getCurrentPosition = (): Thunk => async (dispatch, getState) => {
  // permission is handled by GeolocationServices.getCurrentPosition
  const errorAlreadyDisplayed = geolocationErrorShownSelector(getState());

  try {
    const position = await GeolocationServices.getCurrentPosition();
    return dispatch(setGeoLocation(position));
  } catch (e) {
    /**
     * Error has not already been displayed and permission is currently denied (so we don't display this many times)
     */
    if (!errorAlreadyDisplayed && e.status === 'PERMISSION_DENIED') {
      const browserName = getBrowserName(); // edge, chrome, firefox, safari
      let message = GeolocationBrowserSettingsMessages.default;

      if (GeolocationBrowserSettingsMessages[browserName]) {
        message += GeolocationBrowserSettingsMessages[browserName];
      }

      const error = new Error(message);
      dispatch(
        handleError(error as DfdError, 'warn', () => {
          dispatch(setGeoLocationErrorShown(true));
        })
      );
    }

    return dispatch(setGeoLocationFailure(e));
  }
};

export type GeoLocationAction = ReturnType<typeof setGeoLocation>;
